import {
  Button,
  Col,
  Input,
  Modal,
  Pagination,
  Row,
  Select,
  Space,
  Spin,
  Table,
} from "antd";
import { LoadingOutlined, MenuUnfoldOutlined } from "@ant-design/icons";
import React, { useCallback, useEffect, useState } from "react";
import LiveTestReport from "./LiveTestReport";
import { LIST_LIVE_TESTS } from "../../../apis/apis";
import debounce from "lodash.debounce";
import CulsightPageLoader from "../../../components/CulsightPageLoader";

const { Option } = Select;

function LiveTestList() {
  const [loader, setLoader] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [dataSource, set_dataSource] = useState([]);
  const [current_page, set_current_page] = useState(1);
  const [page_size, set_page_size] = useState(10);
  const [total_records, set_total_records] = useState(0);
  const [pagination_loader, set_pagination_loader] = useState(false);
  const [model_row, set_model_row] = useState(null);
  const [search_query_value, set_search_query_value] = useState("");

  const showModal = (record) => {
    set_model_row(record);
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const columns = [
    { title: "Created On", dataIndex: "created_at", key: "created_at" },
    { title: "Chapter Title", dataIndex: "chapter_title", key: "chapter_title" },
    { title: "Course Title", dataIndex: "course_title", key: "course_title" },
    {
      title: "Timings",
      dataIndex: "timings",
      render: (_, record) => (
        <>
          <span>Available from: </span>{record?.available_from}<br />
          <span>Available till: </span>{record?.available_till}
        </>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => showModal(record)}>
            <MenuUnfoldOutlined style={{ fontSize: "20px" }} />
          </Button>
        </Space>
      ),
    },
  ];

  
  const fetchResults = useCallback(
    debounce(async (search_value) => {
      try {
        set_pagination_loader(true);
        const FORM_DATA = new FormData();
        FORM_DATA.append("title", search_value);
        FORM_DATA.append("page", 1);
        FORM_DATA.append("per_page", page_size);
        const API_CALL = await LIST_LIVE_TESTS(FORM_DATA);
        if (API_CALL?.data?.status) {
          set_dataSource(API_CALL?.data?.data);
          set_current_page(API_CALL?.data?.current_page);
          set_page_size(API_CALL?.data?.page_size || 10);
          set_total_records(API_CALL?.data?.total_records || API_CALL?.data?.total_pages * page_size);
        }
      } catch (err) {
        console.error("API Error:", err);
      } finally {
        set_pagination_loader(false);
      }
    }, 500),
    [page_size]
  );

  const LIST_API = async () => {
    try {
      setLoader(true);
      const FORM_DATA = new FormData();
      FORM_DATA.append("page", 1);
      FORM_DATA.append("per_page", page_size);
      const API_CALL = await LIST_LIVE_TESTS(FORM_DATA);
      if (API_CALL?.data?.status) {
        set_dataSource(API_CALL?.data?.data);
        set_current_page(API_CALL?.data?.current_page);
        set_page_size(API_CALL?.data?.page_size || 10);
        set_total_records(API_CALL?.data?.total_records || API_CALL?.data?.total_pages * page_size);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };

  useEffect(() => {
    LIST_API();
  }, []);

  const handleInput = (e) => {
    const value = e.target.value;
    set_search_query_value(value);
    fetchResults(value);
  };

  const pagination_on_change = async (page, size) => {
    set_pagination_loader(true);
    set_current_page(page);
    set_page_size(size);

    try {
      const FORM_DATA = new FormData();
      FORM_DATA.append("page", page);
      FORM_DATA.append("per_page", size);
      FORM_DATA.append("title", search_query_value);

      const API_CALL = await LIST_LIVE_TESTS(FORM_DATA);
      if (API_CALL?.data?.status) {
        set_dataSource(API_CALL?.data?.data);
        set_current_page(API_CALL?.data?.current_page);
        set_page_size(API_CALL?.data?.page_size || size);
        set_total_records(API_CALL?.data?.total_records || API_CALL?.data?.total_pages * size);
      }
    } catch (err) {
      console.error(err);
    } finally {
      set_pagination_loader(false);
    }
  };

  const selectBefore = (
    <Select defaultValue="Title">
      <Option value="Title">Title</Option>
    </Select>
  );

  return (
    <div>
      
     
      <Row gutter={[16, 16]} align="middle">
        <Col xs={24} sm={24} md={18} lg={20}>
          <Input
            addonBefore={selectBefore}
            placeholder="Search by course title and chapter title"
            onChange={handleInput}
            size="large"
          />
        </Col>
      </Row>

      {loader ? (
        <CulsightPageLoader />
      ) : pagination_loader ? (
        <div style={{ textAlign: "center", padding: "60px" }}>
          <Spin indicator={<LoadingOutlined spin />} size="large" />
        </div>
      ) : (
        <>
          <Row style={{ marginTop: "15px" }}>
            <Col span={24}>
              <Table dataSource={dataSource} columns={columns} pagination={false} />
              {total_records > 0 ? (
                <div style={{ float: "right", marginTop: "20px",marginRight:"-55px" }}>
                  <Pagination
  current={current_page}
  total={total_records}
  pageSize={page_size}
  showSizeChanger
  pageSizeOptions={["10", "20", "50", "100"]}
  onChange={pagination_on_change}
  className="live-test-list-pagination"
/>

                  <style>
                    {`
                      .live-test-list-pagination .ant-pagination-options {
                        display: flex !important;
                        min-width: 200px;
                      }
                      .live-test-list-pagination .ant-select {
                        min-width: 80px !important;
                      }
                    `}
                  </style>
                </div>
              ) : (
                <div style={{ textAlign: "center", color: "red" }}>
                  <h2>No Learner Found</h2>
                </div>
              )}
            </Col>
          </Row>
        </>
      )}

      
      <Modal open={isModalOpen} onCancel={handleCancel} footer={null} width={1100}>
        <LiveTestReport model_row={model_row} />
      </Modal>
    </div>
  );
}

export default LiveTestList;
